import { useEffect, useState } from "react";
import "../assets/styles/views/check-list-form.scss";
import { useLocation, useOutletContext } from "react-router-dom";
import {
  check_list_confirm,
  create_draft,
  get_checklist_form,
} from "../utils/endpoints";
import ReactionList from "../components/ReactionList";
import BackArrowButton from "../components/BackArrowButton";
import EmailChose from "../components/modal-contents/EmailChose";

export default function CheckListForm() {
  const [context, setContext] = useOutletContext();
  const [questions_list, setQuestionsList] = useState();
  const [passed_params, setPassedParams] = useState();
  const [check_list, setCheckList] = useState();
  const location = useLocation();

  useEffect(() => {
    if (location && location.state) setPassedParams(location.state);
  }, [location]);

  useEffect(() => {
    if (!!context.session && questions_list == null && passed_params) {
      (async () => {
        let response = await context.httpRequest(
          "get",
          get_checklist_form,
          null,
          context.session.token
        );
        if (response.result) {
          let obj = { ...response.data };
          obj.jsonDefinition = JSON.parse(obj.jsonDefinition);
          setQuestionsList(obj);
        }

        if (!passed_params.check_list) {
          let draft = await context.httpRequest(
            "post",
            create_draft.replace("*", passed_params.pv_info.pv.codicePv),
            null,
            context.session.token
          );
          if (draft.result) setCheckList(draft.data);
        } else setCheckList(passed_params.check_list);
      })();
    }
  }, [context.session, passed_params]);

  const checkSaveMode = (is_confirmed) => {
    const fields = document.querySelectorAll(
      "#check-list-form input:not(.date)"
    );
    if (fields) {
      fields.forEach((element) => {
        if (is_confirmed) element.setAttribute("required", true);
        else element.removeAttribute("required");
      });
      const save_button = document.querySelector("#save-checklist-form");
      save_button.setAttribute("aria-describedby", is_confirmed);
      save_button.click();
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (check_list && !check_list.isConfirmed) {
      let is_confirmed =
        e.nativeEvent.submitter.getAttribute("aria-describedby") === "true";

      let answer = [];

      questions_list.jsonDefinition.area.map((item, index) => {
        item.questions.map((sub_item, sub_index) => {
          answer.push({
            questionId: sub_item.id,
            idValutazione: parseInt(e.target[`question_${sub_item.id}`].value),
          });
        });
      });

      let obj = { ...check_list };
      obj.trainingDate = `${e.target.training_date.value}T00:00:00`;
      obj.trainingTimeFrom = e.target.training_hour_start.value;
      obj.trainingTimeTo = e.target.training_hour_end.value;
      obj.jsonAnswers = JSON.stringify(answer);

      const response = await context.httpRequest(
        "put",
        create_draft.replace("*", passed_params.pv_info.pv.codicePv),
        obj,
        context.session.token
      );

      if (response.result) {
        if (is_confirmed) {
          const confirm = await context.httpRequest(
            "put",
            check_list_confirm.replace("*", check_list.id),
            null,
            context.session.token
          );

          if (confirm.result) {
            context.openMessage("success", "La checklist è stata confermata!");
            context.navigateUrl("/check-list", {
              state: { pv: passed_params.pv_info, backlink: "/pv-list" },
            });
          }
        } else {
          context.openMessage("success", "La bozza è stata salvata!");
          context.navigateUrl("/check-list", {
            state: {
              pv: passed_params.pv_info,
              backlink: "/pv-list",
            },
          });
        }
      }
    } else if (check_list && check_list.isConfirmed) {
      context.openModal(
        <EmailChose
          check_list_id={check_list.id}
          context={context}
          setContext={setContext}
        />
      );
    }
  };

  return passed_params ? (
    <>
      <BackArrowButton
        state={{ pv: passed_params.pv_info, backlink: "/pv-list" }}
        path="/check-list"
      />
      <section className="check-list-form my-md-5 main-panel w-100 p-3 p-md-0">
        <form id="check-list-form" onSubmit={(e) => handleSave(e)}>
          {questions_list ? (
            <>
              <h1 className="mt-0 mb-4">
                {questions_list.jsonDefinition.title}
              </h1>
              <section className="area-question mx-auto mb-5 border shadow-sm p-3 mb-3">
                <label>Data visita</label>
                <input
                  defaultValue={
                    check_list && check_list.trainingDate
                      ? check_list.trainingDate.split("T")[0]
                      : ""
                  }
                  max={new Date().toISOString().split("T")[0]}
                  name="training_date"
                  type="date"
                  className="date d-block w-100 mb-3"
                  disabled={check_list && check_list.isConfirmed}
                  required
                />
                <div className="d-flex w-100">
                  <div className="w-50 pe-2">
                    <label>Dalle</label>
                    <input
                      defaultValue={
                        check_list && check_list.trainingTimeFrom
                          ? check_list.trainingTimeFrom
                          : ""
                      }
                      disabled={check_list && check_list.isConfirmed}
                      name="training_hour_start"
                      type="time"
                      className="d-block w-100"
                      required
                    />
                  </div>
                  <div className="w-50 ps-2">
                    <label>Alle</label>
                    <input
                      defaultValue={
                        check_list && check_list.trainingTimeTo
                          ? check_list.trainingTimeTo
                          : ""
                      }
                      disabled={check_list && check_list.isConfirmed}
                      name="training_hour_end"
                      type="time"
                      className="d-block w-100"
                      required
                    />
                  </div>
                </div>
              </section>

              {questions_list.jsonDefinition.area.map((item, index) => {
                return (
                  <section
                    className="area-question mx-auto border shadow-sm p-3 mb-5"
                    key={index}
                  >
                    <h2 className="mt-0 mb-3">{item.name}</h2>
                    {item.questions.map((sub_item, sub_index) => {
                      return (
                        <article className="mb-3" key={sub_index}>
                          <strong>{sub_item.text}</strong>
                          <ReactionList
                            check_list={check_list}
                            question_id={sub_item.id}
                          />
                        </article>
                      );
                    })}
                  </section>
                );
              })}
            </>
          ) : null}
          {check_list && !check_list.isConfirmed ? (
            <div className="save-check-list-buttons-container position-sticky mx-auto d-flex py-2 border shadow-sm">
              <button
                type="button"
                onClick={() => checkSaveMode(false)}
                className="q8-blue-button py-2 px-3 mx-auto"
              >
                Salva bozza
              </button>
              <button
                type="button"
                onClick={() => checkSaveMode(true)}
                className="q8-blue-button py-2 px-3 mx-auto"
                aria-describedby="true"
              >
                Salva ed invia
              </button>
              <button id="save-checklist-form" type="submit" className="d-none">
                Salva
              </button>
            </div>
          ) : (
            <div className="save-check-list-buttons-container position-sticky mx-auto d-flex py-2 border shadow-sm">
              <button
                type="submit"
                className="q8-blue-button py-2 px-3 mx-auto"
              >
                Condividi via email
              </button>
            </div>
          )}
        </form>
      </section>
    </>
  ) : null;
}
